<template>
  <div>
    <vs-card>
      <form role="form" @submit.stop.prevent="buscar">
        <div :class="`vx-row pb-0 ${filtroAvancado ? 'sm:pb-0' : 'sm:pb-4'}`">
          <div :class="`vx-col mt-3 sm:w-1/6 w-full`">
            <span> Nº da Cotação </span>
            <vs-input
              class="w-full"
              name="codigo"
              id="codigo"
              v-model="formFiltro.idProposta"
              :state="validateState('codigo')"
              :danger="validateClass('codigo')"
              val-icon-danger="clear"
              data-testId="proposal-id-input"
            />
          </div>

          <div :class="`vx-col mt-3 sm:w-1/6 w-full`">
            <vs-tooltip text="Insira os 6 últimos números">
              <span>
                Nº da Proposta
                <vs-icon
                  class="icon-spacing"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-help-circle"
                ></vs-icon>
              </span>
              <vs-input
                class="w-full"
                v-mask="'######'"
                name="Nº da Proposta"
                id="Nº da Proposta"
                v-model="formFiltro.proposalNumber"
                :state="validateState('Nº da Proposta')"
                :danger="validateClass('Nº da Proposta')"
                val-icon-danger="clear"
                data-testId="proposal-number-input"
              />
            </vs-tooltip>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Tipo Apólice</span>
            <v-select
              :options="listApolices"
              multiple
              name="Tipo de Apólice"
              id="Tipo de Apólice"
              v-model="formFiltro.idTipoApolices"
              :state="validateState('Tipo de Apólice')"
              :class="validateClass('Tipo de Apólice')"
              data-testId="policy-type-select"
            ></v-select>
          </div>

          <div class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Tipo de Data Inicial</span>
            <v-select
              data-testId="initial-date-type-select"
              style="width: 100%"
              :options="tiposDatas"
              name="Tipo de Data Inicial"
              id="Tipo de Data Inicial"
              v-model="formFiltro.tipoData"
            ></v-select>
          </div>

          <div class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Data Inicial</span>
            <datepicker
              data-testId="initial-date-datepicker"
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
            ></datepicker>
          </div>

          <div :class="`vx-col mt-3 sm:w-1/6 w-full`">
            <span>Data Final</span>
            <datepicker
              data-testId="final-date-datepicker"
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>

          <div class="vx-col mt-3 sm:w-1/6 w-full">
            <span>Status</span>
            <v-select
              data-testId="status-select"
              :options="filteredStatus"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>
          <div :class="`vx-col sm:w-1/6 w-full mt-3`">
            <span>Placa</span>
            <vs-input
              data-testId="license-plate-input"
              v-mask="'AAA-#XX#'"
              class="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :state="validateState('Placa')"
              :danger="validateClass('Placa')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>

          <div :class="`vx-col sm:w-1/3 w-full mt-3`">
            <span>Nome do Segurado</span>
            <vs-input
              data-testId="insured-name-autocomplete"
              class="w-full"
              name="Segurado"
              id="Segurado"
              v-model="formFiltro.nomeAssociado"
            />
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Responsável Pela Análise Definido?</span>
            <v-select
              :options="OPCOES_SIM_NAO"
              name="Responsável definido"
              id="Responsável definido"
              v-model="formFiltro.responsavelDefinido"
              :reduce="(item) => item.id"
              :state="validateState('Responsável definido')"
              :class="validateClass('Responsável definido')"
              data-testId="creation-responsible-select"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Corretora</span>
            <PermissionedAutocomplete
              data-testId="broker-select"
              source="broker"
              permission-subject="Vistorias"
              name="Corretora"
              id="Corretora"
              v-model="formFiltro.regional"
            />
          </div>
        </div>

        <div v-if="filtroAvancado" class="vx-row pb-0 sm:pb-4">
          <div
            v-if="$can('Editar Responsável Vistoria', 'Vistorias')"
            class="vx-col sm:w-1/6 w-full mt-3"
          >
            <label for="" class="vs-select--label"
              >Responsável pela Análise</label
            >
            <v-select
              data-testId="inspection-responsible-select"
              :options="colaboradoresCadastro"
              name="Responsável pela Vistoria"
              label="label"
              id="idUsuarioResponsavelVistoria"
              v-model="formFiltro.responsaveisCadastroSelecionados"
              class="select-large w-full"
              :reduce="(item) => item.id"
              v-validate="{ required: true }"
              :state="validateState('Responsável pela Vistoria')"
              :danger="validateClass('Responsável pela Vistoria')"
              multiple
            ></v-select>
          </div>
          <div :class="`vx-col ${b2c ? 'sm:w-1/3' : 'sm:w-1/6'} w-full mt-3`">
            <span>CPF/CNPJ Segurado</span>
            <vs-input
              class="w-full"
              name="CPF"
              id="CPF"
              v-model="formFiltro.cpfCnpjAssociado"
              :state="validateState('CPF')"
              :danger="validateClass('CPF')"
              v-validate="{ min: escolherCPFCNPJMin }"
              v-mask="[DOCUMENT_MASK.CPF_WITH_CNPJ, DOCUMENT_MASK.CNPJ]"
              @input="formFiltro.cpfCnpjAssociado = $event.toUpperCase()"
              val-icon-danger="clear"
              danger-text="CPF ou CNPJ incompletos."
              data-testId="insured-cpf-cnpj-input"
            />
          </div>

          <div class="vx-col sm:w-1/3 w-full mt-3">
            <span>Chassi</span>
            <vs-input
              class="w-full"
              name="chassi"
              id="chassi"
              v-model="formFiltro.chassi"
              :state="validateState('chassi')"
              :danger="validateClass('chassi')"
              v-validate="{ min: 17 }"
              val-icon-danger="clear"
              danger-text="Chassi incorreto ou incompleto"
              data-testId="chassis-input"
            />
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Origem</span>
            <v-select
              data-testId="origin-select"
              :options="origem"
              multiple
              name="Origem"
              id="Origem"
              v-model="formFiltro.origem"
              :reduce="(item) => item.value"
              :state="validateState('Origem')"
              :class="validateClass('Origem')"
            ></v-select>
          </div>

          <div :class="`vx-col sm:w-1/6 w-full mt-3`">
            <span>Usuário</span>
            <PermissionedAutocomplete
              data-testId="user-select"
              source="user"
              permission-subject="Vistorias"
              name="Usuário"
              id="Usuário"
              v-model="formFiltro.consultor"
            />
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3" v-if="b2c">
            <span>Origem App</span>
            <v-select
              data-testId="origin-app-select"
              :options="origemApp"
              name="Origem App"
              id="Origem App"
              v-model="formFiltro.insideApp"
              :state="validateState('Origem App')"
              :class="validateClass('Origem App')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/6 w-full mt-3">
            <span>Estado</span>
            <v-select
              data-testId="state-select"
              :options="estados"
              name="Estado"
              id="Estado"
              v-model="formFiltro.estado"
              @selected="buscaDadosSelectsCidades"
              :state="validateState('Estado')"
              :class="validateClass('Estado')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/4 w-full mt-3">
            <span>Cidade</span>
            <v-select
              data-testId="city-select"
              :options="cidades"
              name="Cidade"
              id="Cidade"
              multiple
              v-model="formFiltro.cidade"
              :state="validateState('Cidade')"
              :class="validateClass('Cidade')"
            ></v-select>
          </div>

          <div class="vx-col sm:w-1/5 w-full mt-3">
            <span>Tipo de Cotação</span>
            <v-select
              data-testid="creation-type-select"
              :options="creationTypeOptions"
              multiple
              name="Tipo de Cotação"
              id="creation-type-select"
              label="label"
              v-model="formFiltro.creationType"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row class="flex justify-end">
          <vs-button
            data-testId="search-button"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar
          </vs-button>
          <vs-button
            data-testId="advanced-search-button"
            @click="buscaFiltrosAvancados()"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            data-testId="clear-button"
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import originSystemApi from '@/services/origin.system.api';
import { DATE_TYPES, OPCOES_SIM_NAO, STATUS_PROPOSTA } from '@/utils/constants';
import notify from '@/utils/notify';
import jwt from 'jsonwebtoken';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import service from '../../services';
import { CREATION_TYPES } from '../../utils/constants';
import locale from './../../locale';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';
import PermissionedAutocomplete from '@/components/filtros/PermissionedAutocomplete.vue';

export default {
  name: 'FiltroVistorias',
  components: {
    Datepicker,
    'v-select': vSelect,
    PermissionedAutocomplete,
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      colaboradoresCadastro: [],
      idEmpresa: null,
      id_usuario: null,
      estados: [],
      cidades: [],
      status: [],
      filtroAvancado: false,
      origemApp: ['Sim', 'Não'],
      tiposDatas: DATE_TYPES,
      origem: [],
      idTipoApolices: null,
      listApolices: [],
      formFiltro: this.getDefaultFormFiltro(),
    };
  },
  created() {
    this.getDecoded();
    this.buscaDadosSelects(
      'domStatusCotacao',
      'status',
      'nomeStatus',
      'idStatus',
    );
    this.buscaColaboradoresDoCadastro();
    this.getOriginSystems();
    this.buscaDadosSelects(
      'tipoApolices',
      'listApolices',
      'nome',
      'tipoApoliceId',
    );

    this.$validator.localize('ptBr', locale);
  },
  computed: {
    OPCOES_SIM_NAO() {
      return OPCOES_SIM_NAO;
    },
    escolherCPFCNPJMin() {
      return this.formFiltro.cpfCnpjAssociado.length <= 14 ? 14 : 18;
    },
    filteredStatus() {
      return this.status
        .filter(
          (status) =>
            status.id !== STATUS_PROPOSTA.COTACAO_CANCELADA.id &&
            status.id !== STATUS_PROPOSTA.COTACAO_RECUSADA.id,
        )
        .sort((a, b) => a.label.localeCompare(b.label));
    },
    creationTypeOptions() {
      return CREATION_TYPES.sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  methods: {
    getDefaultFormFiltro() {
      return {
        idEmpresa: null,
        placa: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        cidade: null,
        estado: null,
        tipoData: DATE_TYPES[0],
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProposta: null,
        proposalNumber: null,
        responsaveisCadastroSelecionados: [],
        responsavelDefinido: null,
        cpfCnpjAssociado: '',
        chassi: null,
        idTipoApolices: null,
        creationType: [],
      };
    },
    limparFiltro() {
      this.formFiltro = this.getDefaultFormFiltro();
      this.buscar();
    },
    dataInicio() {
      const filtroDiasAnteriores = 30;
      let dataAtual = new Date();
      const dataInicio = dataAtual.setDate(
        dataAtual.getDate() - filtroDiasAnteriores,
      );
      return dataInicio;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              [
                STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id,
                STATUS_PROPOSTA.PENDENTE.id,
                STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id,
                STATUS_PROPOSTA.VISTORIA_EXPIRADA.id,
              ].includes(element[campoPK])
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }

      this.idEmpresa = this.decoded.id_empresa;
      this.id_usuario = this.decoded.id_usuario;
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.formFiltro.estado) {
        return;
      }

      this.$vs.loading();

      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Falha buscar cidades',
            text: e,
            color: 'danger',
          });
        });
    },
    buscar() {
      this.formFiltro.filtred = true;
      this.$emit('filtro', this.formFiltro);
    },
    async buscaColaboradoresDoCadastro() {
      const idSetorCadastro = await this.buscarIdDoSetorCadastro();
      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idSetor: idSetorCadastro.id,
        })
        .then((res) => {
          this.colaboradoresCadastro = res.data.map((colaborador) => {
            return {
              id: colaborador.idUsuario,
              label: colaborador.nome,
            };
          });
          this.colaboradoresCadastro.unshift({ label: 'Selecione', id: null });

          this.$emit('obterColaboradoresCadastro', this.colaboradoresCadastro);
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    buscarIdDoSetorCadastro() {
      return new Promise((resolve, reject) => {
        service
          .post('Setor', 'buscar-id-setor-por-nome', {
            idEmpresa: this.idEmpresa,
            nomeSetor: 'cadastro',
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((e) => {
            this.$vs.loading.close();
            reject(e);
          });
      });
    },
    buscaFiltrosAvancados() {
      if (!this.filtroAvancado) {
        this.filtroAvancado = true;

        this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');

        if (this.status.length == 0) {
          this.buscaDadosSelects(
            'domStatusCotacao',
            'status',
            'nomeStatus',
            'idStatus',
          );
        }
      } else this.filtroAvancado = false;
    },
    getOriginSystems() {
      originSystemApi
        .getOriginSystems()
        .then((res) => {
          this.origem = res.map((origin) => {
            return {
              value: origin.key,
              label: origin.name,
            };
          });
        })
        .catch((e) => {
          notify.notifyFail(this.$vs, 'Falha ao buscar origens', e);
        });
    },
  },
  watch: {
    'formFiltro.estado'(value) {
      this.formFiltro.cidade = null;
      if (value) {
        this.buscaDadosSelectsCidades(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      } else {
        this.cidades = [];
      }
    },
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
